import { ExpandableErrorAlert } from '@/components/ExpandableErrorAlert';
import { Message } from '@/components/Message';
import { MessageUnionType, RunSchema } from '@/types/schema';
import {
  getMessageContent,
  getMessageFields,
  getMessageType,
  isMessageLike,
} from '@/utils/messages';
import { getTopLevelError } from '@/utils/stringUtils';

import { RunOutput } from '../Run/components/RunOutput';
import { getPlaygroundChatModelOutput } from './PlaygroundChatModelOutput.utils';
import { usePlaygroundStore } from './PlaygroundHome/hooks/usePlaygroundStore';

function PlaygroundChatModelOutputInner(props: {
  isInputHidden?: boolean;
  run?: RunSchema | null;
}) {
  const input =
    (props.run?.inputs?.messages as MessageUnionType[] | undefined) ?? [];

  const output = props.run ? getPlaygroundChatModelOutput(props.run) : null;
  const enableMarkdown = usePlaygroundStore((state) => state.enableMarkdown);

  const isInputEmpty =
    props.isInputHidden || (Array.isArray(input) && input.length === 0);
  const isOutputEmpty = !output;

  if (props.run?.error) {
    return <ExpandableErrorAlert error={getTopLevelError(props.run.error)} />;
  }

  if (isInputEmpty && isOutputEmpty) return null;

  return (
    <div className="flex flex-col gap-5">
      {!props.isInputHidden &&
        Array.isArray(input) &&
        input?.map?.((message, index) => (
          <Message
            key={index}
            testid={`playground-input-message-${index}`}
            role={getMessageType(message) ?? 'HUMAN'}
            content={getMessageContent(message) ?? ''}
            fields={getMessageFields(message)}
            omitMaxHeight
          />
        ))}

      {output && (
        <div className="flex flex-col gap-3">
          {isMessageLike(output) ? (
            <Message
              testid={`playground-output-message-${props.run?.status}`}
              role={getMessageType(output) ?? 'ASSISTANT'}
              content={getMessageContent(output) ?? ''}
              fields={getMessageFields(output)}
              omitMaxHeight
              enableMarkdown={enableMarkdown}
            />
          ) : (
            <RunOutput outputs={output} />
          )}
        </div>
      )}
    </div>
  );
}

export function PlaygroundChatModelOutput(props: {
  isInputHidden?: boolean;
  run?: RunSchema | null;
}) {
  return <PlaygroundChatModelOutputInner {...props} />;
}
